<template>
  <div v-if="visible" class="dialog-overlay">
    <div class="dialog">
      <h3>{{ title }}</h3>
      <p>{{ content }}</p>
      <button @click="closeDialog">关闭</button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

// 定义 props
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  title: {
    type: String,
    default: "默认标题",
  },
  content: {
    type: String,
    default: "默认内容",
  },
  visible: {
    type: Boolean,
    default: false,
  },
});

// 定义 emit
const emit = defineEmits(["update:visible"]);

// 关闭 Dialog 的方法
const closeDialog = () => {
  emit("update:visible", false);
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
</style>